export default __webpack_public_path__ + "static/media/CityLights06.fbce27cc.jpg";